import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { PerxState } from 'MyTypes';

/**
 * This hook behaves exactly the same as useSelector, except that it comes with the global state type
 */
const useTypedSelector: TypedUseSelectorHook<PerxState> = useSelector;
export default useTypedSelector;
